import { ReactNode } from 'react'
import { Asset } from 'contentful'
import Image from '@/components/contentful/Image'

interface IconGroupProps {
  title: string
  description: ReactNode
  dataCy: string
  image?: Asset
}

const IconGroup = ({ title, description, dataCy, image }: IconGroupProps) => (
  <div
    className="items-between mb-6 flex flex-1 flex-col px-4 md:mb-0 md:px-6"
    data-cy={dataCy}
  >
    <div className="flex flex-row items-center md:flex-col md:items-start">
      {image && (
        <div className="flex h-20 items-center">
          <Image image={image} width={78} />
        </div>
      )}
      <h3 className="ml-3 text-xl leading-tight md:ml-0">{title}</h3>
    </div>
    <div className="text-xs md:mt-2">{description}</div>
  </div>
)

export default IconGroup
